// extracted by mini-css-extract-plugin
export default {"pEvaluateC":"index_pEvaluateC__w+06+","left":"index_left__O7zqP","right":"index_right__-T9+3","arrowRight":"index_arrowRight__h9U7+"};